import { createCrudActions } from '../utils/crudGenerator';

const formatSpenttypes = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchSpenttypes,
    create: createSpenttype,
    update: updateSpenttype,
    delete: deleteSpenttypes
} = createCrudActions('SPENTTYPE', "TipoGasto", formatSpenttypes);